const path = {
    HOME_PREFIX: '/',
    SKILLS_PREFIX: '/skills',
    WORKS_PREFIX: '/projects',
    CONTACT_PREFIX: '/contact',
    FRONTEND_PREFIX: '/frontend',
    BACKEND_PREFIX: '/backend',
    OVERVIEW_PREFIX: '/overview',
}

export default path;